import { EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import he from 'he';
import React, { useMemo } from 'react';

import AspectRatio from '@/components/common/AspectRatio';
import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';
import { htmlToParagraphs } from '@/utility/htmlToParagraphs';

import ClampedText from '../switchback/ClampedText/ClampedText';

type TRichTextSectionProps = {
  section_type?: 'rich_text';
  title: string;
  title_type?: 'header' | 'subtitle';
  image?: string;
  content: string;
  background?: string;
};

export const RichTextSection = ({
  title,
  title_type = 'header',
  image,
  content,
}: TRichTextSectionProps) => {
  const paragraphs = useMemo(() => htmlToParagraphs(he.decode(content)), [content]);

  return (
    <div className="flex flex-col md:flex-row gap-10">
      <div className="flex flex-col items-start w-full grow md:w-2/3">
        <Heading
          variant={title_type === 'subtitle' ? EHeadingStyleVariant.H6 : EHeadingStyleVariant.H4}
          component={title_type === 'subtitle' ? 'h6' : 'h2'}
          className="mb-4">
          {title}
        </Heading>
        {paragraphs.length > 1 ? (
          <ClampedText
            paragraphClasses="text-600 my-2"
            buttonClassName="my-2 text-lg font-medium text-gray-800"
            clamp={4}
            readMore
            readLess
            underline={false}>
            {paragraphs.join('\n\n')}
            <span className="hidden" />
          </ClampedText>
        ) : (
          <p className="my-2 text-600">{content}</p>
        )}
      </div>

      {image && (
        <div className="w-full md:w-1/3 md:min-w-[300px]">
          <AspectRatio ratio="4:3" hasImageHover>
            <ResponsiveImage src={image} />
          </AspectRatio>
        </div>
      )}
    </div>
  );
};
